"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBodyFont = setBodyFont;
exports.setNumberedList = setNumberedList;
exports.setSubHeadingFont = setSubHeadingFont;
exports.genSubTitle = genSubTitle;
exports.genSubIntroOrderedList = genSubIntroOrderedList;
exports.genSubOrderedList = genSubOrderedList;
exports.genSubUnorderedList = genSubUnorderedList;
exports.genPersonasList = genPersonasList;
exports.commColours = exports.pdfDoc = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var pdfDoc = {
  width: 210,
  height: 297,
  titleX: 21,
  titleY: 68,
  copyInitialX: 15,
  copyInitialY: 89,
  copyIndentX: 27.5,
  copyIndentXOrdered: 33
};
exports.pdfDoc = pdfDoc;
var commColours = {
  '1': '#0031BF',
  '2': '#00ADDC',
  '3': '#008E7F',
  '4': '#B72267',
  '5': '#F2A00A',
  '6': '#5A5758'
};
exports.commColours = commColours;

function setBodyFont(pdf, weight, textColour) {
  if (textColour === void 0) {
    textColour = '#000';
  }

  pdf.setFontSize(10);
  pdf.setTextColor(textColour);
  pdf.setFont('ProximaNova', weight);
  pdf.setCharSpace(0);
  pdf.setLineHeightFactor(1.2);
}

function setNumberedList(pdf) {
  pdf.setFontSize(10);
  pdf.setTextColor('#00aec7');
  pdf.setFont('ProximaNova', 'bold');
  pdf.setCharSpace(0);
  pdf.setLineHeightFactor(1.2);
}

function setSubHeadingFont(pdf, textColour, weight) {
  if (textColour === void 0) {
    textColour = '#00aec7';
  }

  if (weight === void 0) {
    weight = 'bold';
  }

  pdf.setFont('ProximaNova', weight);
  pdf.setFontSize(14);
  pdf.setTextColor(textColour);
  pdf.setLineHeightFactor(1.2);
}

function genSubTitle(_x, _x2, _x3) {
  return _genSubTitle.apply(this, arguments);
}

function _genSubTitle() {
  _genSubTitle = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(pdf, title, currentY) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setSubHeadingFont(pdf);
            pdf.text(pdf.splitTextToSize(title, pdfDoc.width - pdfDoc.titleX - 54), pdfDoc.copyInitialX, currentY //* needs more spacing following a paragraph
            );
            return _context.abrupt("return", currentY += pdf.getTextDimensions(pdf.splitTextToSize(title, pdfDoc.width - pdfDoc.titleX - 54)).h + pdf.getLineHeight() / 3.33);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _genSubTitle.apply(this, arguments);
}

function genSubIntroOrderedList(_x4, _x5, _x6, _x7) {
  return _genSubIntroOrderedList.apply(this, arguments);
}

function _genSubIntroOrderedList() {
  _genSubIntroOrderedList = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(pdf, section, currentY, textColour) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (textColour === void 0) {
              textColour = '#000';
            }

            section.label = section.messages[0];
            section.messages = section.messages.slice(1);
            _context2.next = 5;
            return genSubTitle(pdf, section.label, currentY);

          case 5:
            currentY = _context2.sent;
            section.messages.forEach(function (entry, i) {
              var text = isNaN(entry[0]) ? entry : entry.slice(3);
              setNumberedList(pdf);
              pdf.text(i + 1 + ". ", pdfDoc.copyIndentX, currentY);
              setBodyFont(pdf, 'normal', textColour);
              pdf.text(pdf.splitTextToSize(text, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54), pdfDoc.copyIndentXOrdered, currentY);
              currentY = currentY + pdf.getTextDimensions(pdf.splitTextToSize(text, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54)).h + pdf.getLineHeight() / 3.5;
            });
            currentY += pdf.getLineHeight() / 2; //* needs more spacing following a paragraph

            return _context2.abrupt("return", currentY);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _genSubIntroOrderedList.apply(this, arguments);
}

function genSubOrderedList(_x8, _x9, _x10, _x11) {
  return _genSubOrderedList.apply(this, arguments);
}

function _genSubOrderedList() {
  _genSubOrderedList = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(pdf, section, currentY, textColour) {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (textColour === void 0) {
              textColour = '#000';
            }

            section.messages.forEach(function (entry, i) {
              var text = isNaN(entry[0]) ? entry : entry.slice(3);
              setNumberedList(pdf);
              pdf.text(i + 1 + ". ", pdfDoc.copyIndentX, currentY);
              setBodyFont(pdf, 'normal', textColour);
              pdf.text(pdf.splitTextToSize(text, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54), pdfDoc.copyIndentXOrdered, currentY);
              currentY = currentY + pdf.getTextDimensions(pdf.splitTextToSize(text, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54)).h + pdf.getLineHeight() / 3.5;
            });
            currentY += pdf.getLineHeight() / 2; //* needs more spacing following a paragraph

            return _context3.abrupt("return", currentY);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _genSubOrderedList.apply(this, arguments);
}

function genSubUnorderedList(_x12, _x13, _x14, _x15, _x16) {
  return _genSubUnorderedList.apply(this, arguments);
}

function _genSubUnorderedList() {
  _genSubUnorderedList = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(pdf, section, currentY, textColour, doSub) {
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (textColour === void 0) {
              textColour = '#000';
            }

            if (doSub === void 0) {
              doSub = false;
            }

            if (!doSub) {
              _context4.next = 6;
              break;
            }

            _context4.next = 5;
            return genSubTitle(pdf, section.label, currentY);

          case 5:
            currentY = _context4.sent;

          case 6:
            section.messages.forEach(function (entry, i) {
              setBodyFont(pdf, 'normal', textColour);
              pdf.text(pdf.splitTextToSize("\u2022  " + entry, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54), pdfDoc.copyIndentX, currentY);
              currentY = currentY + pdf.getTextDimensions(pdf.splitTextToSize(entry, pdfDoc.width - pdfDoc.copyIndentXOrdered - 54)).h + pdf.getLineHeight() / 3.5;
            });
            currentY += pdf.getLineHeight() / 2;
            return _context4.abrupt("return", currentY);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _genSubUnorderedList.apply(this, arguments);
}

function genPersonasList(_x17, _x18, _x19, _x20, _x21) {
  return _genPersonasList.apply(this, arguments);
}

function _genPersonasList() {
  _genPersonasList = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(pdf, section, currentY, textColour, hasSubHeading) {
    var longestOne;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (textColour === void 0) {
              textColour = '#000';
            }

            // TODO: find fix for having to hardcode width here. without,
            // width of getTextDim comes back a lot wider than it really is
            longestOne = hasSubHeading ? 48.46 : pdf.getTextDimensions('202 Healthy, Wealthy and Wise').w;
            section.messages.sort().forEach(function (entry, i) {
              var _pdf$getTextDimension = pdf.getTextDimensions(entry),
                  rectHeight = _pdf$getTextDimension.h;

              var topPad = hasSubHeading && i === 0 ? 1 : 2;
              var bottomPad = hasSubHeading && i === 0 ? 4 : 5;
              pdf.setFillColor(commColours[entry[0]]);
              pdf.roundedRect(pdfDoc.copyIndentX - 2, currentY - rectHeight - topPad, longestOne + 4, rectHeight + bottomPad, 1, 1, 'F');
              setBodyFont(pdf, 'normal', textColour);
              pdf.text(entry, pdfDoc.copyIndentX, currentY);
              currentY = currentY + pdf.getTextDimensions(entry).h + pdf.getLineHeight() / 2;
            });
            currentY += pdf.getLineHeight() / 2;
            return _context5.abrupt("return", currentY);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _genPersonasList.apply(this, arguments);
}